import { render, staticRenderFns } from "./ingresar-productos.vue?vue&type=template&id=5ef586bb&scoped=true"
import script from "./ingresar-productos.vue?vue&type=script&lang=js"
export * from "./ingresar-productos.vue?vue&type=script&lang=js"
import style0 from "./ingresar-productos.vue?vue&type=style&index=0&id=5ef586bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef586bb",
  null
  
)

export default component.exports